<h1>{{nombre}}</h1>

<dl>
    <td>Nombre:</td>
    <dd>{{nombre}}</dd>
</dl>
<dl>
    <td>Edad:</td>
    <dd>{{edad}}</dd>
</dl>
<dl>
    <td>Funcion:</td>
    <dd>{{obtenerNombre()}}</dd>
</dl>
<dl>
    <td>Capitalizado:</td>
    <dd>{{nombreCapitalizado}}</dd>
</dl>

<button (click) = 'cambiarHeroe()'>Cambiar Heroe</button>
<button (click) = 'cambiarEdad()'>Cambiar edad</button>